/**
 * Date utility functions for job detail page
 */

/**
 * Formats a date string using Intl.DateTimeFormat
 * @param dateString - ISO date string
 * @param locale - Locale string (e.g., 'en', 'fi', 'sv')
 * @returns Formatted date string or null if invalid
 */
export function formatDate(dateString: string | undefined, locale: string): string | null {
  if (!dateString) return null;
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return null;
    
    return new Intl.DateTimeFormat(locale, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    }).format(date);
  } catch (error) {
    return null;
  }
}

/**
 * Calculates estimated expiry date (35 days from posted date) if application deadline is missing
 * @param applicationDeadline - Application deadline date string (optional)
 * @param postedDate - Posted date string
 * @returns ISO date string of estimated expiry or null
 */
export function calculateEstimatedExpiryDate(
  applicationDeadline: string | undefined,
  postedDate: string | undefined
): string | null {
  if (applicationDeadline) return null; // If we have a deadline, don't estimate
  if (!postedDate) return null;
  
  try {
    const posted = new Date(postedDate);
    if (isNaN(posted.getTime())) return null;
    
    const estimated = new Date(posted);
    estimated.setDate(estimated.getDate() + 35);
    
    return estimated.toISOString();
  } catch {
    return null;
  }
}

